<template>
  <div class="backgroundZonaDescarga" id="background5">
    <div class="transbox" id="transbox5">
      <h1 class="pulse">Zona de Descargas</h1>
      <br>
      <div class="wrapper">
        <a href="http://lg-legitrans.com/descargas/AAI_BOCYL.pdf">
        <div class="container" id="c0">
          <img src="../assets/legitrans web/aai.png">
          <div class="story" id="s0">
            <div class="info" id="style-2">
              <a>Autorización Ambiental Integrada.</a>
            </div>
          </div>
        </div>
        </a>
        <a href="http://lg-legitrans.com/descargas/COVID%20PRACTICAS%20DE%20PREVENCION%20DE%20LEGITRANS_2020.pdf">
        <div class="container" id="c1">
          <img src="../assets/legitrans web/covid.jpg">
          <div class="story" id="s1">
            <div class="info" id="style-2">
              <a>Medidas covid-19.</a>
            </div>
          </div>
        </div>
        </a>
        <a href="http://lg-legitrans.com/descargas/Inscripciones%20JCYL.pdf"  >
        <div class="container" id="c2">
          <img src="../assets/legitrans web/inscripcionesjcyl.png">
          <div class="story" id="s2">
            <div class="info" id="style-2">
              <a>Inscripciones JCYL.</a>
            </div>
          </div>
        </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Productos',
  props: {
    msg: String
  },
  data: () => ({
    length: 3,
    onboarding: 0
  }),
  methods: {
    next () {
      this.onboarding = this.onboarding + 1 === this.length
        ? 0
        : this.onboarding + 1
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? this.length - 1
        : this.onboarding - 1
    }
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#background5").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox5").classList.add("animation")
      } 
    })
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}

img{
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5%;
  padding-bottom: 20%;
  width: 100%;
  height: 95%;
}


div.backgroundZonaDescarga {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}

div.transbox {
   margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  transition: opacity 0.5s;
  min-width: 750px;
}

div {
  font-size: 30px;
}

.animation{
  animation-name: opacity1;
  animation-duration: 1500ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}

.wrapper {
  top: 10%;
  left: 25%;
  bottom: 25%;
  right: 25%;
  width: inherit;
  height: 545px;
  perspective: 900px;
}

.container {
  position: absolute;
  top: 0%;
  width: 100%;
  height: 100%;
  transition: .5s all ease;
  transform: rotateX(60deg) scale(0.7);
  perspective: 900px;
  box-shadow: 0px 20px 50px #555;
  animation: entry 1s linear 1;
}

#c0 {
  top: 0%;
  width: 25%;
  height: 100%;
  background: linear-gradient(to bottom, #eba65b 30%, #d99267 100%);
  z-index: 300;
  left: 37.5%;
  box-shadow: 0px 20px 100px #555;
}

#c1 {
  background: linear-gradient(to bottom, #59476f 30%, #7b88d1 100%);
  box-shadow: 0px 20px 100px #555;
  left: 70%;
   width: 25%;
  z-index: 0;
}

#c2 {
  left: 5%;
   width: 25%;
  z-index: 0;
  background: linear-gradient(to bottom, #59476f 30%, #7b88d1 100%);
  box-shadow: 0px 20px 100px #555;
}

.container:hover {
  cursor: pointer;
  transform: rotate(0deg) scale(1) translateY(10px);
  transition: .5s all ease;
  z-index: 400;
}

#style-2::-webkit-scrollbar-track
{
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar
{
    width: 12px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #59476f;
}

.story {
  position: absolute;
  top: 85%;
  left: 0%;
  height: 15%;
  width: 100%;
  background: linear-gradient(to bottom, #eba65b 0%, #d99267 40%);
}

#s1 {
  background: linear-gradient(to top, #5b62a2 0%, #7b88d1 100%);
}

#s2 {
  background: linear-gradient(to top, #5b62a2 0%, #7b88d1 120%);
}

  .info {
    top: 10%;
    overflow:auto;
    max-height: 410px;
    text-align: center;
    
  }

h3 {
  text-align: center;
  text-shadow: 0px 0px 10px #eee;
  color: #eee;
  letter-spacing: 2px;
}

h4 {
  color: #111;
  position: absolute;
  top: 30%;
  left: 30%;
  letter-spacing: 2px;
}

a {
  color: black;
}

p {
  font-size: 14px;
  color: black;
  font-weight: 1000;
  padding: 0px 20px 20px 20px;
  line-height: 150%;
  text-align: justify;
  letter-spacing: 1px;
}

@keyframes simple {
  50% {
    transform: translateX(10px);
    opacity: 0.5;
  }
  100% {
    transform: translateX(10px);
    opacity: 0;
  }
}

@keyframes simple1 {
  50% {
    transform: translateX(-10px);
    opacity: 0.5;
  }
  100% {
    transform: translateX(-10px);
    opacity: 0;
  }
}

@keyframes entry {
  0% {
    top: -20%;
    opacity: 0.1;
  }
  100% {
    top: 0%;
  }
}
.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>